<template>
  <path d="M0 4H4V0H0V4ZM6 16H10V12H6V16ZM0 16H4V12H0V16ZM0 10H4V6H0V10ZM6 10H10V6H6V10ZM6 4H10V0H6V4Z" fill="#e0e2e5"/>
</template>

<script>
    export default {
        name: 'icon-draggable'
    }
</script>